// import th from 'date-fns/locale/th'

export const DATE_PICKER_FORMAT = 'DD-MM-YYYY'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const REQUEST_DATE_FORMAT = 'YYYY/MM/DD'
export const DD_MM_YYYY_SLASH = 'DD/MM/YYYY'
export const DD_MM_YYYY = 'dd-MM-yyyy'
export const DATE_TIME_FORMAT = 'DDMMyyyyhhmmss'

export const LOCAL_DAY_TH = {
  sunday: 'อาทิตย์',
  monday: 'จันทร์',
  tuesday: 'อังคาร',
  wednesday: 'พุธ',
  thursday: 'พฤหัสบดี',
  friday: 'ศุกร์',
  saturday: 'เสาร์',
  ok: 'ตกลง',
  today: 'วันนี้',
  yesterday: 'เมื่อวานนี้',
  hours: 'ชั่วโมง',
  minutes: 'นาที',
  seconds: 'วินาที',
}

export const MONTHS_TH = [
  { value: 1, label: 'มกราคม' },
  { value: 2, label: 'กุมภาพันธ์' },
  { value: 3, label: 'มีนาคม' },
  { value: 4, label: 'เมษายน' },
  { value: 5, label: 'พฤษภาคม' },
  { value: 6, label: 'มิถุนายน' },
  { value: 7, label: 'กรกฎาคม' },
  { value: 8, label: 'สิงหาคม' },
  { value: 9, label: 'กันยายน' },
  { value: 10, label: 'ตุลาคม' },
  { value: 11, label: 'พฤศจิกายน' },
  { value: 12, label: 'ธันวาคม' },
]
